import { render } from "./BlckTrackDocuments.vue?vue&type=template&id=5b83c7a4&scoped=true"
import script from "./BlckTrackDocuments.vue?vue&type=script&lang=js"
export * from "./BlckTrackDocuments.vue?vue&type=script&lang=js"

import "./BlckTrackDocuments.vue?vue&type=style&index=0&id=5b83c7a4&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b83c7a4"]])

export default __exports__